import { AdminCMSRepositoryInterface } from '@/data/persistences/repositories/contracts/AdminCMSRepositoryInterface'
import ApiService from '@/app/framework/services/ApiServices'
import { AdminCMSMapper } from '@/data/persistences/mappers/AdminCMSMapper'
import { UserCMS } from '@/domain/entities/adminCMS'
import {
  CreateAdminCMSRequestInterface,
  UpdateAdminCMSInterface,
  DeleteAdminCMSRequestInterface,
} from '@/data/payload/contracts/AdminRequest'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import {
  CreateAdminCMSRequest,
  UpdateAdminCMSRequest,
  DeleteAdminRequest,
} from '@/data/payload/api/AdminCMSRequest'

export class AdminCMSApiRepository implements AdminCMSRepositoryInterface {
  private service: ApiService
  private mapper: AdminCMSMapper

  constructor(service: ApiService, mapper: AdminCMSMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAdminRole(
    params: Object
  ): Promise<Array<Record<string, number | string>>> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.ADMIN_ROLE_LIST,
      params
    )
    return this.mapper.convertRoleCMSMapper(resp)
  }

  public async getAll(params: Object): Promise<UserCMS> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.ADMIN_CMS,
      params
    )
    return this.mapper.convertAdminCMSMapper(resp)
  }

  public async update(
    payload: UpdateAdminCMSInterface,
    id: number
  ): Promise<UserCMS> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.ADMIN_CMS}/${id}`,
      undefined,
      payload as UpdateAdminCMSRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }
  public async create(
    payload: CreateAdminCMSRequestInterface
  ): Promise<UserCMS> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.ADMIN_CMS,
      undefined,
      payload as CreateAdminCMSRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async delete(
    payload: DeleteAdminCMSRequestInterface
  ): Promise<UserCMS> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.USERS_CMS_DELETE,
      undefined,
      payload as DeleteAdminRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }
}
